import { Skeleton } from '@wwe-portal/ui/components/skeleton';
import { cn } from '@wwe-portal/ui/lib/lib';

export const NavigationSkeleton = ({ length = 4 }) => {
  const arr = new Array<number>(length).fill(0);
  return (
    <div
      className={cn(
        'z-sticky bg-bgColor23 no-scrollbar sticky top-[55px] flex w-auto flex-row flex-nowrap gap-[10px] overflow-auto py-3 text-xs 2xl:top-[70px]'
      )}
    >
      {arr.map((_, index) => (
        <NavigationItemSkeleton key={index} />
      ))}
    </div>
  );
};

const NavigationItemSkeleton = () => {
  return (
    <div className="ml-1">
      <Skeleton className="h-[28px] w-[110px]" />
    </div>
  );
};
